import { IsRequiredValidation } from "../CreateDeviceProfile/formValidation";

export default function setLocationIntoStep3(locs) {
  let locations = [];

  if (Array.isArray(locs)) {
    locations = locs;
  }

  const originIndex = locations.findIndex(
    (location) =>
      location.currentLocation !== "" &&
      location[location.currentLocation].shipping.value === "Origin"
  );

  if (originIndex === -1) {
    locations = [
      ...locations,
      {
        currentLocation: "",
        existing: {
          shipping: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
          pointName: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          address: {
            isValid: false,
            class: "",
            value: "",
            error: "",
            mapBoxTheme: {
              cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
              variables: {
                unit: "14px",
                padding: "0.5em",
                border: "1px solid rgba(111, 113, 113, 1)",
                borderRadius: "4px",
                boxShadow: "none",
              },
            },
          },
          latitude: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          longitude: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          radius: {
            isValid: true,
            class: "",
            value: "",
            error: "",
          },
          trigger: {
            isValid: false,
            class: "",
            value: "entry and exit",
            error: "",
          },
          alerttype: {
            isValid: false,
            class: "",
            value: "notification",
            error: "",
          },
          alertgroup: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
        },
        new: {
          shipping: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
          pointName: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          address: {
            isValid: false,
            class: "",
            value: "",
            error: "",
            mapBoxTheme: {
              cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
              variables: {
                unit: "14px",
                padding: "0.5em",
                border: "1px solid rgba(111, 113, 113, 1)",
                borderRadius: "4px",
                boxShadow: "none",
              },
            },
          },
          latitude: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          longitude: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          radius: {
            isValid: true,
            class: "",
            value: "",
            error: "",
          },
          trigger: {
            isValid: false,
            class: "",
            value: "entry and exit",
            error: "",
          },
          alerttype: {
            isValid: false,
            class: "",
            value: "notification",
            error: "",
          },
          alertgroup: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
        },
      },
    ];
  }

  const destinationIndex = locations.findIndex(
    (location) =>
      location.currentLocation !== "" &&
      location[location.currentLocation].shipping.value === "Destination"
  );

  if (destinationIndex === -1) {
    locations = [
      ...locations,
      {
        currentLocation: "",
        existing: {
          shipping: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
          pointName: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          address: {
            isValid: false,
            class: "",
            value: "",
            error: "",
            mapBoxTheme: {
              cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
              variables: {
                unit: "14px",
                padding: "0.5em",
                border: "1px solid rgba(111, 113, 113, 1)",
                borderRadius: "4px",
                boxShadow: "none",
              },
            },
          },
          latitude: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          longitude: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          radius: {
            isValid: true,
            class: "",
            value: "",
            error: "",
          },
          trigger: {
            isValid: false,
            class: "",
            value: "entry and exit",
            error: "",
          },
          alerttype: {
            isValid: false,
            class: "",
            value: "notification",
            error: "",
          },
          alertgroup: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
        },
        new: {
          shipping: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
          pointName: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          address: {
            isValid: false,
            class: "",
            value: "",
            error: "",
            mapBoxTheme: {
              cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
              variables: {
                unit: "14px",
                padding: "0.5em",
                border: "1px solid rgba(111, 113, 113, 1)",
                borderRadius: "4px",
                boxShadow: "none",
              },
            },
          },
          latitude: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          longitude: {
            isValid: false,
            class: "",
            value: "",
            error: "",
          },
          radius: {
            isValid: true,
            class: "",
            value: "",
            error: "",
          },
          trigger: {
            isValid: false,
            class: "",
            value: "entry and exit",
            error: "",
          },
          alerttype: {
            isValid: false,
            class: "",
            value: "notification",
            error: "",
          },
          alertgroup: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
        },
      },
    ];
  }

  locations = locations.map((location) => {
    let locationResult = location;
    const locationKeys = Object.keys(location).filter(
      (loc) => loc !== "radius"
    );

    locationKeys
      .filter((locKey) => locKey !== "currentLocation")
      .forEach((locKey) => {
        const validator = IsRequiredValidation(locKey, location[locKey].value);

        if (locKey === "address") {
          let mapBoxTheme = {
            cssText: `
                    .Input {
                        height: 43px;
                        font-size: 1rem;
                        font-weight: 400;
                        color: #212529;
                        font-family: system-ui;
                        pointer-events: none;
                    }
                    .ClearBtn {
                        display: none !important;
                    }
                `,
            variables: {
              unit: "14px",
              padding: "0.5em",
              border: "1px solid rgba(111, 113, 113, 1)",
              borderRadius: "4px",
              boxShadow: "none",
            },
          };
          if (validator.isValid) {
            mapBoxTheme = {
              ...mapBoxTheme,
              cssText: `
                  .Input {
                      height: 43px;
                      font-size: 1rem;
                      font-weight: 400;
                      color: #000;
                      background-color: #dcf5e6;
                      font-family: system-ui;
                      pointer-events: none;
                  }
                  .ClearBtn {
                      display: none !important;
                  }
              `,
              variables: {
                unit: "14px",
                padding: "0.5em",
                border: "1px solid rgb(99, 184, 132)",
                borderRadius: "4px",
                boxShadow: "none",
              },
            };
          } else {
            mapBoxTheme = {
              ...mapBoxTheme,
              cssText: `
                .Input {
                    height: 43px;
                    font-size: 1rem;
                    font-weight: 400;
                    color: #000;
                    background-color: #ffece0;
                    font-family: system-ui;
                    pointer-events: none;
                }
                .ClearBtn {
                    display: none !important;
                }
            `,
              variables: {
                unit: "14px",
                padding: "0.5em",
                border: "1px solid #ba2626",
                borderRadius: "4px",
                boxShadow: "none",
              },
            };
          }

          locationResult = {
            ...locationResult,
            [locKey]: {
              ...locationResult[locKey],
              ...validator,
              mapBoxTheme,
            },
          };
        } else {
          locationResult = {
            ...locationResult,
            [locKey]: {
              ...locationResult[locKey],
              ...validator,
            },
          };
        }
      });

    return locationResult;
  });

  let isValidForNext = false;
  const originLocationIndex = locations.findIndex(
    (location) =>
      location.currentLocation !== "" &&
      location[location.currentLocation].shipping.value === "Origin" &&
      location[location.currentLocation].pointName.value !== "" &&
      location[location.currentLocation].address.value !== "" &&
      location[location.currentLocation].latitude.value !== "" &&
      location[location.currentLocation].longitude.value !== "" &&
      location[location.currentLocation].radius.value !== ""
  );

  const destinationLocationIndex = locations.findIndex(
    (location) =>
      location.currentLocation !== "" &&
      location[location.currentLocation].shipping.value === "Destination" &&
      location[location.currentLocation].pointName.value !== "" &&
      location[location.currentLocation].address.value !== "" &&
      location[location.currentLocation].latitude.value !== "" &&
      location[location.currentLocation].longitude.value !== "" &&
      location[location.currentLocation].radius.value !== ""
  );

  const hasError = locations
    ?.filter((locKey) => locKey !== "currentLocation")
    .some((loc) =>
      Object.values(loc).some(
        (field) => field?.class === "shipment-form-field-error"
      )
    );

  if (
    originLocationIndex !== -1 &&
    destinationLocationIndex !== -1 &&
    !hasError
  ) {
    isValidForNext = true;
  }

  return {
    locations,
    isValidForNext,
  };
}
